import Pubnub from 'pubnub';

import config from 'src/config';

const CHANNELS = {
  NP_COMPANY_GUESTLIST: 'NP_COMPANY_GUESTLIST_',
  NP_COMPANY_RESERVATION: 'NP_COMPANY_RESERVATION_',
  NP_COMPANY_AVAILABLE_LAYOUT_TABLE: 'NP_COMPANY_AVAILABLE_LAYOUT_TABLE_',
  DATA_EXPORT_GENERATE_COMPLETED_CREATED_BY_MEMBER: 'DATA_EXPORT_GENERATE_COMPLETED#CREATED_BY_MEMBER#',
  DATA_EXPORT_GENERATE_COMPLETED_CREATED_BY_ADMIN: 'DATA_EXPORT_GENERATE_COMPLETED#CREATED_BY_ADMIN#',
  DATA_EXPORT_GENERATE_FAILED_CREATED_BY_MEMBER: 'DATA_EXPORT_GENERATE_FAILED#CREATED_BY_MEMBER#'
};

class PubsubService {
  constructor($q, $window, $timeout) {
    this._$q = $q;
    this._$window = $window;
    this._$timeout = $timeout;
  }

  get CHANNELS() { //eslint-disable-line
    return CHANNELS;
  }

  subscribe(channel, callback) {
    const $timeout = this._$timeout;

    const pubnubClient = new Pubnub({
      subscribeKey: config.PUBNUB_SUB_KEY,
      ssl: true
    });

    pubnubClient.addListener({
      message(response) {
        if (callback) {
          $timeout(() => {
            callback(response.message);
          });
        }
      }
    });

    pubnubClient.subscribe({
      channels: [channel]
    });

    return pubnubClient;
  }
}

PubsubService.$inject = [
  '$q',
  '$window',
  '$timeout'
];

export default PubsubService;



// WEBPACK FOOTER //
// ./src/services/pubsubService.js